import {isHomeworkBetaEnabled} from 'common/helpers'
import {lazy, useEffect, useRef, useState} from 'react'
import {Alert} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import {Location, useLocation} from 'react-router'
import {MainReducer, RootState, UserReducer} from 'setup'

import {getAsideMenuLinks} from '_metronic/layout/components/sidebar/sidebar-menu/SidebarLinks'
import {PageLink, PageTitle} from '_metronic/layout/core'

const CustomIFrame = lazy(() => import('../../../../../common/components/CustomIFrame'))

const NewHomeworkManagerAlert = () => {
  const {pathname} = useLocation()

  if (!pathname.startsWith('/institute/homework') || !isHomeworkBetaEnabled()) {
    return null
  }

  return (
    <Alert className='mt-n5' variant='info' dismissible>
      New homework manager is coming soon, please press <strong>Try new version</strong> button to
      experience it. Review the introductory video by clicking{' '}
      <a href='https://www.youtube.com/watch?v=2eoSTsKdbYU' target='_blank' rel='noreferrer'>
        here
      </a>
      .
    </Alert>
  )
}

const SchoolWrapper = () => {
  const mainReducer = useSelector<RootState>((rootState) => rootState.mainReducer) as MainReducer
  const userReducer = useSelector<RootState>((rootState) => rootState.userReducer) as UserReducer
  const AsideMenuLinks = getAsideMenuLinks({mainReducer, userReducer})

  const intl = useIntl()
  const location = useLocation()
  const {pathname, search} = location
  const prevLocationRef = useRef<Location>(null)

  // eslint-disable-next-line
  const [iframeLoading, setIframeLoading] = useState(true)
  const [breadcrumb, setBreadCrumb] = useState<PageLink[]>([])
  const [category, setCategory] = useState('')
  const [iframeUrlChangeCount, setIframeUrlChangeCount] = useState(0)

  useEffect(() => {
    const path = search === '' ? pathname : pathname + search

    let currentCategory = ''
    const currentBreadcrumb: PageLink[] = []

    for (let i = 0; i < AsideMenuLinks.length; i++) {
      const menuLink = AsideMenuLinks[i]

      if (menuLink.to === path) {
        const menuTitleHasTranslation = !!intl.messages[menuLink.title]
        currentCategory = menuTitleHasTranslation ? intl.$t({id: menuLink.title}) : menuLink.title

        break
      } else if (menuLink.subLinks && menuLink.subLinks.length > 0) {
        for (let j = 0; j < menuLink.subLinks.length; j++) {
          const link = menuLink.subLinks[j]
          if (link.to === path) {
            const menuTitleHasTranslation = !!intl.messages[menuLink.title]
            currentCategory = menuTitleHasTranslation
              ? intl.$t({id: menuLink.title})
              : menuLink.title

            const subMenuTitleHasTranslation = !!intl.messages[link.title]
            const subMenuTitle = subMenuTitleHasTranslation ? intl.$t({id: link.title}) : link.title
            currentBreadcrumb.push({title: subMenuTitle, path, isSeparator: false, isActive: true})
            break
          }
        }
        if (currentBreadcrumb && currentBreadcrumb.length > 0) {
          break
        }
      }
    }

    setCategory(currentCategory)
    setBreadCrumb(currentBreadcrumb)

    setIframeLoading(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  useEffect(() => {
    if (prevLocationRef.current?.pathname === location.pathname) {
      setIframeUrlChangeCount(iframeUrlChangeCount + 1)
      setIframeLoading(true)
    } else {
      setIframeUrlChangeCount(0)
    }

    prevLocationRef.current = location
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  const iframePostMessageListener = (event: MessageEvent<any>) => {
    const {data} = event
    if (data instanceof Object && data.type === 'loading') {
      if (data.loading) {
        setIframeLoading(true)
        setTimeout(() => {
          setIframeLoading(false)
        }, 8000)
      } else {
        setIframeLoading(false)
      }
    }
  }

  useEffect(() => {
    window.addEventListener('message', iframePostMessageListener, false)

    return () => {
      window.removeEventListener('message', iframePostMessageListener, false)
    }
  }, [])

  return (
    <>
      <PageTitle description='' breadcrumbs={breadcrumb}>
        {category}
      </PageTitle>

      <NewHomeworkManagerAlert />

      <CustomIFrame path={pathname} className='position-relative' />
    </>
  )
}

export default SchoolWrapper
